import { files, impactBusinessesRef } from "@/fireinit.js";
import axios from "axios";
import Vue from "vue";

export default {
  loadAll: async ({ commit, rootState }) => {
    const response = await axios.get(
      `${rootState.axios.API}impactBusiness/all/available`
    );
    let impactBusinessList = [];
    let keywordToBusinessID = {};
    response.data.forEach((business) => {
      let businessData = business;
      business.buyerSelected = parseInt(business.buyerSelected);
      business.supplierSelected = parseInt(business.supplierSelected);
      impactBusinessList.push({ id: business.id, ...business });
      keywordToBusinessID[businessData.urlKeyword] = businessData.id;
    });
    commit("setImpactBusinessList", impactBusinessList);
    commit("setKeywordToBusinessID", keywordToBusinessID);
  },
  loadAllAdmin: async ({ commit, rootState }, columnDefs = []) => {
    commit("setImpactBusinessList", []);
    const response = await axios.get(
      `${rootState.axios.API}impactBusiness/all`,
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );

    let impactBusinessList = [];
    let keywordToBusinessID = {};
    response.data.forEach((business) => {
      let businessData = business;
      business.buyerSelected = parseInt(business.buyerSelected);
      business.supplierSelected = parseInt(business.supplierSelected);
      impactBusinessList.push({ id: business.id, ...business });
      keywordToBusinessID[businessData.urlKeyword] = businessData.id;
    });
    commit("setImpactBusinessList", impactBusinessList);
    commit("setKeywordToBusinessID", keywordToBusinessID);
  },
  loadProfile: async ({ commit, state, rootState }, id) => {
    let response = null;

    try {
      response = await axios.get(`${rootState.axios.API}impactBusiness/${id}`, {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      });
    } catch (error) {
      response = await axios.get(`${rootState.axios.API}impactBusiness/${id}`);
    }

    let business = response.data[0];

    commit("setLoading", false);
    commit("setCurrentProfile", business);
  },
  filter: async ({ commit, state, dispatch }, filter) => {
    let uppercaseSearch = filter.toUpperCase();
    if (state.list.length < 1) {
      dispatch("loadAll").then(() => {
        let result = state.list.filter(
          (IB) => IB.name.toUpperCase().indexOf(uppercaseSearch) > -1
        );
        commit("setFilteredList", result);
      });
    } else {
      let result = state.list.filter(
        (IB) =>
          IB.name.toUpperCase().indexOf(uppercaseSearch) > -1 &&
          IB.status === "Live Report"
      );
      commit("setFilteredList", result);
    }
  },
  loadProfileByKeyword: async ({ commit, state, rootState }, keyword) => {
    let response = null;

    commit("setLoading", true);

    try {
      response = await axios.get(
        `${rootState.axios.API}impactBusiness/keyword/${keyword}`,
        {
          headers: {
            Authorization: `Bearer ${rootState.user.data.auth._lat}`,
          },
        }
      );
    } catch (error) {
      response = await axios.get(
        `${rootState.axios.API}impactBusiness/keyword/${keyword}`
      );
    }

    let business = response.data[0];

    commit("setLoading", false);
    commit("setCurrentProfile", business);
  },
  delete: async ({ commit, rootState, dispatch }, ID) => {
    let updateImpactBusiness = await axios.post(
      `${rootState.axios.API}impactBusiness/delete`,
      {
        id: ID,
      },
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );

    dispatch("loadAllAdmin");
  },
  save: async ({ commit, rootState, dispatch }, impactBusiness) => {
    if (impactBusiness.id) {
      // Uploading Image
      if (impactBusiness.image != undefined) {
        let uploadImageResult = await axios.post(
          `${rootState.axios.API}impactBusiness/updateProfileImage`,
          { id: impactBusiness.id, imageData: impactBusiness.image.dataUrl },
          {
            headers: {
              Authorization: `Bearer ${rootState.user.data.auth._lat}`,
            },
          }
        );
        delete impactBusiness.image;
        if (uploadImageResult.data.Result == "Success") {
          impactBusiness.imageUrl = uploadImageResult.data.objectUrl;
        }
      }

      impactBusiness.firebase_id = null;

      let updateImpactBusiness = await axios.post(
        `${rootState.axios.API}impactBusiness/update`,
        impactBusiness,
        {
          headers: {
            Authorization: `Bearer ${rootState.user.data.auth._lat}`,
          },
        }
      );
      Vue.notify({
        type: "success",
        duration: 3000,
        title: "Save Successful",
        text: "Impact Buyer has successfully been saved",
      });
      return impactBusiness;
    } else {
      let createImpactBusiness = await axios.post(
        `${rootState.axios.API}impactBusiness/create`,
        impactBusiness,
        {
          headers: {
            Authorization: `Bearer ${rootState.user.data.auth._lat}`,
          },
        }
      );

      let impactBusiness_id = createImpactBusiness.data.impactBusinessID;

      let response = await axios.get(
        `${rootState.axios.API}impactBusiness/${impactBusiness_id}`,
        {
          headers: {
            Authorization: `Bearer ${rootState.user.data.auth._lat}`,
          },
        }
      );

      impactBusiness = response.data;
      dispatch("loadAllAdmin");

      Vue.notify({
        type: "success",
        duration: 3000,
        title: "Creation Successful",
        text: "Impact Buyer has successfully been created",
      });
      return impactBusiness[0];
    }
  },
  saveWorkItemImage: async ({ commit }, workItem) => {
    if (workItem.image) {
      let file = workItem.image.file;
      const metadata = {
        contentType: file.type,
      };
      let imageFile = await files
        .child(`workItemImages/${workItem.impactBusiness_id}_${workItem.idx}`)
        .put(file, metadata);
      let downloadUrl = await imageFile.ref.getDownloadURL();
      return downloadUrl;
    }
  },
  createLogin: async ({ commit, dispatch }, impactBusiness) => {
    if (impactBusiness.uid) {
      dispatch("notification/alert", "Good Cause already has a ");
    }
  },
  createSupplier: async ({ commit, rootState }, data) => {
    await axios.post(
      `${rootState.axios.API}business/createSupplierFromBusiness`,
      data,
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );
  },
  createFromSalesEnquiry: async ({ commit, rootState, dispatch }, data) => {
    let result = await axios.post(
      `${rootState.axios.API}impactBusiness/createFromSalesEnquiry`,
      data,
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );
    dispatch("loadAllAdmin");
    return result.data;
  },
  reviewOpportunityButtonClicked: async ({ rootState }) => {
    await axios.post(
      `${rootState.axios.API}actionsCenter/reviewOpportunitiesClicked`,
      {},
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    )
  }
};
